import {autoserializeAs, inheritSerialization} from 'cerialize';
import {MomentTransformer} from '../helpers/moment-transformer';
import * as moment from 'moment';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class Foto extends ModelBase {
  public static readonly type = 'Foto';
  public readonly type = Foto.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('uploader_id')
  public uploaderId: number;

  @autoserializeAs('uploader')
  public uploader: string;

  @autoserializeAs(MomentTransformer, 'created_at')
  public createdAt: moment.Moment;

  @autoserializeAs('url')
  public url: string;

  @autoserializeAs('thumbnail_url')
  public thumbnailUrl: string;
}
